import { getOpenUserStore, openUserStoreFromSession, type UserStore } from './store';
import type { HazardLexicon } from './types';

/**
 * Lexicon accessors for services. Rows live in the open user store (tenant
 * vocabulary); the device store no longer holds a lexicon.
 */

async function storeOrNull(): Promise<UserStore | null> {
  const open = getOpenUserStore();
  if (open) {
    return open;
  }
  return openUserStoreFromSession();
}

/** Replace the stored lexicon. Throws when no user store can be opened so a successful fetch is never dropped silently. */
export async function replaceLexicon(rows: HazardLexicon[]): Promise<void> {
  const store = await storeOrNull();
  if (!store) {
    throw new Error('User store is not open');
  }
  await store.replaceLexicon(rows);
}

/** Read the stored lexicon; empty when no user store can be opened. */
export async function listLexicon(): Promise<HazardLexicon[]> {
  const store = await storeOrNull();
  if (!store) {
    return [];
  }
  return store.listLexicon();
}
